import axios from "axios";
import { toast } from "react-hot-toast";

//var API_BASE_URL = window.APP_CONFIG?.API_URL;   //server///
var API_BASE_URL = 'http://attendance.inurum.com/'


const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Fixing token retrieval
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      // Trim any whitespace and ensure token is valid
      const cleanToken = token.trim();
      if (cleanToken) {
        config.headers.Authorization = `Bearer ${cleanToken}`;
        console.log('Token added to request:', cleanToken.substring(0, 20) + '...');
      } else {
        console.warn('Token exists but is empty after trimming');
      }
    } else {
      console.warn('No token found in localStorage');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      const currentPath = window.location.pathname;

      if (status === 401) {
        // Token expired or unauthorized, redirect to login
        console.error("Unauthorized! Redirecting to login...");
        localStorage.removeItem("token");
        if (currentPath !== "/dashboard") {
          window.location.href = "/dashboard";
        }
      } else if (status === 403) {
        console.error("Forbidden! You don't have permission.");
        const errorMessage = error.response?.data?.message || error.response?.data?.error || '';
        
        // Check if it's a role-based access error
        if (errorMessage.toLowerCase().includes('role') || errorMessage.toLowerCase().includes('unauthorized')) {
          toast.error(
            errorMessage || "Access denied: Unauthorized role. You don't have permission to access this resource."
          );
        } else {
          toast.error(
            errorMessage || "Access denied! You don't have permission to perform this action."
          );
        }
      }
      else if (status >= 500) {
        console.error("Server error! Please try again later.");
        toast.error("Something went wrong on the server.");
      }
    } else {
      console.error("Network error or request failed.");
      toast.error("Network error or request failed.");
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;